export enum CardBrands {
    AmericanExpress = 'amex',
    DinersClub = 'diners',
    Discover = 'discover',
    Jcb = 'jcb',
    Mastercard = 'mastercard',
    Other = 'other',
    Visa = 'visa',
}

export type CreditCardAddress = {
    address1: string;
    address2?: string;
    city: string;
    countryCode: string;
    firstName?: string;
    lastName?: string;
    organizationName?: string;
    phoneNumber?: string;
    postalCode: string;
    singleLineAddress?: string;
    state?: string;
};

export type CreditCard = {
    address: CreditCardAddress;
    brand: CardBrands;
    created?: Date;
    customerId: string;
    defaultCard?: boolean;
    id: number;
    last4: string;
    month: number;
    name: string;
    providerId: number;
    token: string;
    year: number;
};
